const VISITOR_ID_STORAGE_KEY = "kf_visitor_id";

function canUseStorage(): boolean {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

function generateVisitorId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `v_${crypto.randomUUID()}`;
  }

  const randomPart = Math.random().toString(36).slice(2, 12);
  return `v_${Date.now().toString(36)}_${randomPart}`;
}

export function getVisitorId(): string | null {
  if (!canUseStorage()) {
    return null;
  }

  try {
    return window.localStorage.getItem(VISITOR_ID_STORAGE_KEY);
  } catch (error) {
    console.warn("Failed to read visitor id from storage:", error);
    return null;
  }
}

export function getOrCreateVisitorId(): string {
  const existingVisitorId = getVisitorId();
  if (existingVisitorId) {
    return existingVisitorId;
  }

  const visitorId = generateVisitorId();
  if (canUseStorage()) {
    try {
      window.localStorage.setItem(VISITOR_ID_STORAGE_KEY, visitorId);
    } catch (error) {
      console.warn("Failed to persist visitor id:", error);
    }
  }

  return visitorId;
}

export function getEffectiveLogUid(): string {
  return getOrCreateVisitorId();
}
